import React from 'react'
import Honeybadger from 'honeybadger-js'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      onQueryError // via withQueryResults
    } = props

    // add user info to Honeybadger context
    const handleQueryCompleted = data => {
      const { viewer: account } = data || {}
      if (account) {
        Honeybadger.setContext({
          user_id: account.id,
          user_email: account.email,
          user_first_name: account.user.firstName
        })
      }
    }

    // react hooks
    const { loading, data } = useQuery(query, {
      onError: onQueryError,
      onCompleted: handleQueryCompleted
    })

    // GraphQL data
    const { viewer: account } = data || {}

    return <WrappedComponent loading={loading} account={account} {...props} />
  }
}

export default withQuery
